import React from "react";
// @ts-ignore
import { LazyLoadImage } from "react-lazy-load-image-component";

export default function LazyImage(
  props: React.DetailedHTMLProps<
    React.ImgHTMLAttributes<HTMLImageElement>,
    HTMLImageElement
  >
) {
  return <LazyLoadImage {...props} />;
}
